import { render, staticRenderFns } from "./offersList.vue?vue&type=template&id=1a344894&"
import script from "./offersList.vue?vue&type=script&lang=js&"
export * from "./offersList.vue?vue&type=script&lang=js&"
import style0 from "./offersList.vue?vue&type=style&index=0&id=1a344894&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports